import { SiOpenaigym } from "react-icons/si";

export const links = [
    {
        name: "Home",
        path: "/",
    },
    {
        name: "Historique",
        path: "/about",
    },
    {
        name: "Gallerie",
        path: "/gallery",
    },
    {
        name: "Formations",
        path: "/plans",
    },
    {
        name: "Staff",
        path: "/staff",
    },
    {
        name: "Contact",
        path: "/contact",
    },
];

export const programs = [
    {
        id: 1,
        icon: <SiOpenaigym />,
        title: "Ingenieur mobile Natif",
        info: " Maîtrisez les langages et les frameworks nécessaires pour créer des applications mobiles natives de haute qualité. Développez des compétences spécialisées et plongez-vous dans le monde passionnant du développement mobile natif.",
        path: "/programs/111",
    },
    {
        id: 2,
        icon: <SiOpenaigym />,
        title: "Ingenieur Mobile Flutter",
        info: "Explorez Flutter, le framework multiplateforme révolutionnaire, et apprenez à développer des applications mobiles attrayantes pour iOS et Android. Acquérez une expertise en conception d'interfaces utilisateur fluides et en déploiement d'applications performantes.",
        path: "/programs/222",
    },
    {
        id: 3,
        icon: <SiOpenaigym />,
        title: "Ingenieur Web",
        info: "Plongez dans le développement web et devenez un expert des technologies clés telles que HTML, CSS et JavaScript. Apprenez à créer des sites web interactifs et adaptatifs, tout en comprenant les principes fondamentaux du développement web moderne.",
        path: "/programs/333",
    },
    {
        id: 4,
        icon: <SiOpenaigym />,
        title: "Ingenieur Fullstack",
        info: "Devenez un développeur polyvalent en combinant les compétences du développement mobile et du développement web. Maîtrisez à la fois les aspects frontend et backend pour créer des applications mobiles complètes et intégrées avec des fonctionnalités avancées.",
        path: "/programs/444",
    },
];

export const value = [
    {
        id: 1,
        icon: <SiOpenaigym />,
        title: "Création de Site Internet",
        desc: "Nous concevons et développons des sites web personnalisés pour répondre à vos besoins spécifiques. Du design à la fonctionnalité, nous créons des sites attractifs et conviviaux qui vous aident à vous démarquer sur le web."
    },
    {
        id: 2,
        icon: <SiOpenaigym />,
        title: "Création d'applications Mobile",
        desc: "Nous développons des applications mobiles sur mesure pour iOS et Android. De la planification à la mise en œuvre, nous vous aidons à transformer votre idée en une application mobile fonctionnelle, intuitive et esthétiquement plaisante.",
    },
    {
        id: 3,
        icon: <SiOpenaigym />,
        title: "Création d'applications Ordinateur",
        desc: " Nous concevons des applications logicielles pour ordinateurs qui répondent à vos exigences professionnelles ou personnelles. Qu'il s'agisse d'une application de gestion interne ou d'un logiciel spécialisé, nous vous offrons des solutions sur mesure pour répondre à vos besoins.",
    },
    {
        id: 4,
        icon: <SiOpenaigym />,
        title: "Formation et Stage",
        desc: " Nous proposons des programmes de formation et des stages pour vous aider à développer vos compétences dans le domaine du développement web et de la création d'applications. Nos formations sont dispensées par des professionnels expérimentés, vous permettant d'acquérir les connaissances et l'expérience pratique nécessaires pour réussir.",
    },
];

export const faqs = [
    {
        id: 1,
        question: "Quels sont les services que vous proposez ?",
        answer:
            "Nous proposons des formations et des services de création de sites internet sur mesure, de développement d'applications mobiles et de formations personnalisées dans le domaine du développement web et mobile.",
    },
    {
        id: 4,
        question: "Comment puis-je démarrer avec vos services ?",
        answer:
            "Pour commencer,vous pouvez nous contacter via notre section contact ou par téléphone pour discuter de votre projet et de vos besoins spécifiques.Nous serons ravis de vous guider tout au long du processus.",
    },
    {
        id: 3,
        question: "Comment m'inscrire à une de vos Formations?",
        answer:
            "Pour commencer, vous pouvez  vous rendre à TilituLab situé au sein de la maison des jeunes ou au cabinet Cre situé à côté de la station CAP Tomdé.",
    },
    {
        id: 2,
        question: "Quand Débute la Prochaine Vague? ",
        answer:
            "La prochaine vague de formation est fixé débutera les cours le 24 Juillet 2023",
    },
    {
        id: 5,
        question: "Quelles technologies utilisez-vous pour développer les sites internet et les applications mobiles ?",
        answer:
            "Nous utilisons une combinaison de technologies modernes et éprouvées, telles que HTML, CSS, JavaScript, React, Flutter et bien d'autres, pour développer des sites internet et des applications mobiles robustes et performantes.",
    },
    {
        id: 6,
        question: "Est-ce que vous proposez des services de référencement et de marketing digital ?",
        answer:
            "Oui, nous proposons des services de référencement et de marketing digital pour optimiser la visibilité de votre site internet ou de votre application mobile sur les moteurs de recherche et les plateformes en ligne.",
    },
];

export const testimonials = [
    {
        id: 1,
        name: "Diana Ayi",
        quote:
            "J'ai été impressionnée par la qualité du service fourni par cette agence. Ils ont su comprendre mes besoins et créer un site internet qui correspond parfaitement à mes attentes. Je les recommande vivement !",
        job: "Etudiante",
        avatar: require("./images/avatar1.jpg"),
    },
    {
        id: 2,
        name: "Daniel Vinyo",
        quote:
            "Je suis très satisfait du travail de cette agence. Leur expertise en développement logiciel est remarquable. Ils ont su créer une application mobile innovante pour mon entreprise. Je les recommande sans hésitation !",
        job: "Ingenieur Logiciel",
        avatar: require("./images/avatar2.jpg"),
    },
    {
        id: 3,
        name: "Edem Quist",
        quote:
            "J'ai suivi une formation avec cette agence et j'ai été agréablement surpris par la qualité des cours dispensés. Les formateurs sont compétents et ont su répondre à toutes mes questions. Je recommande leurs services de formation !",
        job: "Etudiant",
        avatar: require("./images/avatar3.jpg"),
    },
    {
        id: 4,
        name: "Grace Lavoe",
        quote:
            "Cette agence m'a aidé à développer mon site internet professionnel. Leur équipe d'ingénieurs a fait un excellent travail et a su apporter des solutions créatives à mes besoins. Je suis très satisfait de leur travail !",
        job: "Ingenieur",
        avatar: require("./images/avatar4.jpg"),
    },
    {
        id: 5,
        name: "Nana Yaa Dankwa",
        quote:
            "J'ai fait appel à cette agence pour la création de mon site internet. Leur professionnalisme et leur attention aux détails m'ont impressionné. Je suis ravie du résultat final et je les recommande chaudement !",
        job: "Pharmacienne",
        avatar: require("./images/avatar5.jpg"),
    },
];

export const plans = [
    {
        id: 1,
        name: "Developpement Web",
        desc: "Ce forfait est parfait pour les débutants qui souhaitent apprendre le développement web et acquérir des compétences en HTML, CSS, JavaScript, ReactJS, Node.js, Firebase et jQuery.",
        price: "50.000",
        features: [
            { feature: "HTML", available: true },
            { feature: "CSS", available: true },
            { feature: "JavaScript", available: true },
            { feature: "ReactJs", available: true },
            { feature: "MongoDB", available: false },
            { feature: "GraphQL", available: false },
            { feature: "Express", available: false },
            { feature: "NodeJs", available: true },
            { feature: "Firebase", available: true },
            { feature: "Mysql", available: false },
            { feature: "Bootstrap", available: false },
            { feature: "JQuery", available: true },
            { feature: "AWS", available: false },
        ],
    },
    {
        id: 2,
        name: "Développement Mobile Natif",
        desc: "Ce forfait est parfait pour les développeurs débutants qui souhaitent se spécialiser dans le développement d'applications mobiles natives utilisant les modules suivants :",
        price: "70.000",
        features: [
            { feature: "React Native", available: true },
            { feature: "JavaScript", available: true },
            { feature: "Redux", available: true },
            { feature: "React Navigation", available: true },
            { feature: "Axios", available: false },
            { feature: "AsyncStorage", available: true },
            { feature: "Firebase", available: true },
            { feature: "Push Notifications", available: true },
            { feature: "Google Maps", available: true },
            { feature: "Camera", available: true },
            { feature: "Image Picker", available: true },
            { feature: "Authentication", available: true },
            { feature: "API Integration", available: true },
        ],
    }
,
    {
        id: 3,
        name: "Développement Mobile Flutter",
        desc: "Ce forfait est parfait pour les développeurs débutants qui souhaitent se spécialiser dans le développement d'applications mobiles multiplateformes en utilisant les modules suivants :",
        price: "70.000",
        features: [
            { feature: "Flutter", available: true },
            { feature: "Dart", available: true },
            { feature: "Widgets", available: true },
            { feature: "Material Design", available: true },
            { feature: "Cupertino", available: true },
            { feature: "Firebase", available: true },
            { feature: "REST API Integration", available: true },
            { feature: "State Management", available: true },
            { feature: "HTTP Requests", available: true },
            { feature: "SQLite", available: false },
            { feature: "Authentication", available: true },
            { feature: "Push Notifications", available: true },
            { feature: "Device Features", available: true },
        ],
    },

    {
        id: 4,
        name: "Développeur Fullstack ",
        desc: "Ce forfait est idéal pour les développeurs souhaitant maîtriser le développement Fullstack avec React et les technologies connexes.",
        price: "90.000",
        features: [
            { feature: "ReactJs", available: true },
            { feature: "React Native", available: true },
            { feature: "Node.js", available: true },
            { feature: "Express.js", available: true },
            { feature: "MongoDB", available: true },
            { feature: "HTML", available: true },
            { feature: "CSS", available: true },
            { feature: "JavaScript", available: true },
            { feature: "RESTful API", available: true },
            { feature: "Authentication", available: true },
            { feature: "Database Integration", available: false },
            { feature: "State Management", available: true },
            { feature: "Frontend UI Frameworks", available: true },
            { feature: "Backend Development", available: false },
            { feature: "Deployment", available: true },
        ],
    }
,
];

const Trainer1 = require("./img/bio.jpg");
const Trainer3 = require("./img/hugues.jpg");
const Trainer4 = require("./img/me1.jpg");

export const trainers = [
    {
        id: 1,
        image: Trainer1,
        name: "Seth Agba",
        job: "Formateur Developpement Web",
        socials: [
            "https://wa.me/+22890579946",
            "https://facebook.com/",
            "https://linkedin.com/",
            "https://youtube.com/",
        ],
    },
   
    {
        id: 3,
        image: Trainer3,
        name: "Hugues S.",
        job: "Formateur Developpement Flutter",
        socials: [
            "https://wa.me/+22890660225",
            "https://facebook.com/",
            "https://linkedin.com/",
            "https://youtube.com/",

        ],
    },
    {
        id: 4,
        image: Trainer4,
        name: "Seth Agba",
        job: "Formateur Developpement Fullstack",
        socials: [
            "https://wa.me/+22890579946",
            "https://facebook.com/",
            "https://linkedin.com/",
            "https://youtube.com/",

        ],
    },
    
];
